/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureLogAnalyticsWorkspaceDetails {
    getFixupPrototypeFunction() { return AzureLogAnalyticsWorkspaceDetails.fixupPrototype; }

    static newInstance(model: Partial<AzureLogAnalyticsWorkspaceDetails>): AzureLogAnalyticsWorkspaceDetails {
        let obj = Object.assign(new AzureLogAnalyticsWorkspaceDetails(), model);
        AzureLogAnalyticsWorkspaceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureLogAnalyticsWorkspaceDetails>): AzureLogAnalyticsWorkspaceDetails {
        if (!model) return null;
        return AzureLogAnalyticsWorkspaceDetails.newInstance(<AzureLogAnalyticsWorkspaceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureLogAnalyticsWorkspaceDetails) {
        if (!obj) return;

        models.AzureLogAnalyticsWorkspaceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureLogAnalyticsWorkspaceDetails): boolean {
        Object.setPrototypeOf(obj, AzureLogAnalyticsWorkspaceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Resource Id
     */
    resource_id: string;

    /**
     * Workspace Name
     */
    name: string;

    /**
     * Workspace Id
     */
    workspace_id: string;

}
